@if ((!_pinned && _expanded) || _overlayExpanded) {
    <div class="lg-slideout__underlay" (click)="_onBackdropClick()"></div>
}

<lg-slideout-holder
    [variant]="variant"
    [width]="_panelWidth ?? width"
    [expanded]="_expanded"
    [pinned]="_pinned"
    [hidePin]="_hidePin"
    (pinToggled)="_togglePin()"
    (shown)="_onShown()"
    (hidden)="_onHidden()"
>
    <lg-slideout-holder-header
        [slideoutApi]="slideoutApi"
        slot="pinned"
        (pinToggled)="pinToggled.emit()"
    />
    @if (_expanded) {
        @if (_template) {
            <ng-template
                *ngTemplateOutlet="_template; context: { $implicit: _templateContext }"
            ></ng-template>
        } @else {
            <ng-content></ng-content>
        }
    }
</lg-slideout-holder>

@if (_overlayExpanded) {
    <div class="lg-slideout__overlay-dimmer"></div>
}

<lg-slideout-holder
    class="lg-slideout-holder--overlay"
    [variant]="variant"
    [width]="_overlayPanelWidth ?? width"
    [expanded]="_overlayExpanded"
    [pinned]="false"
    [hidePin]="_overlayHidePin"
    (shown)="_onOverlayShown()"
    (hidden)="_onOverlayHidden()"
>
    <lg-slideout-holder-header
        [slideoutApi]="_overlayApi"
        slot="overlay"
        (pinToggled)="pinToggled.emit()"
    />
    @if (_overlayExpanded) {
        @if (_overlayTemplate) {
            <ng-template
                *ngTemplateOutlet="
                    _overlayTemplate;
                    context: { $implicit: _overlayTemplateContext }
                "
            ></ng-template>
        }
    }
</lg-slideout-holder>
